import { Dialog, Transition } from '@headlessui/react'
import { Fragment, SyntheticEvent, useState } from 'react'
import { toast } from 'react-hot-toast'
import { useDispatch, useSelector } from 'react-redux'
import { useCloseAccountMutation } from '../../../features/auth/authApiSlice'
import { logout, selectCurrentUser } from '../../../features/auth/authSlice'
import { SuccessIcon } from '../../../shared/SuccessIcon'

export const CloseAccount = () => {
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false)

  const user = useSelector(selectCurrentUser)

  const [closeAccount, { isError, isLoading }] = useCloseAccountMutation()

  const [isAcceptTerms, setIsAcceptTerms] = useState(false)

  const dispatch = useDispatch()

  const handleCloseAccount = async (event: SyntheticEvent) => {
    event.preventDefault()
    try {
      await closeAccount().unwrap()
      setIsSuccessModalOpen(true)

      setTimeout(() => {
        dispatch(logout())
      }, 3000)
    } catch (error) {
      toast.error('Failed to close account')
    }
  }

  return (
    <div className='w-full max-w-lg mx-auto md:py-12 px-4'>

      <div className='flex flex-col gap-2 mt-8'>


        <h2 className='text-2xl font-semibold text-white'>Close Account</h2>

        <p className='text-base text-white/60'>
          Are you sure you want to close your account?
        </p>

        <p className='text-base text-white/60'>
          We're sad to see you go! Before you proceed, please consider the following:
        </p>

        <ul className='text-base text-white/60 list-disc list-inside'>
          <li>Loss of Data: Any saved information associated with your account will be permanently deleted.</li>
          <li>Loss of Access: You will lose access to your account and any associated benefits.</li>
          <li>Unable to Recover: Once closed, accounts cannot be reopened. You'll need to create a new account if you wish to use our services again.</li>
        </ul>

        <p className='text-base text-white/60'>
          If you still wish to proceed, please confirm by clicking the button below.
        </p>



        <label htmlFor='terms' className='text-base text-white/60'>
          <input onChange={(event) => {
            setIsAcceptTerms(event.target.checked)
          }} type='checkbox' id='terms' name='terms' className='text-zinc-400 mr-2 cursor-pointer' />
          By closing your account, you agree to our Terms of Service and Privacy Policy. If you have any questions or concerns, please <a href='https://gcbuying.com/about-us' className='text-blue-400'>contact us</a>.
        </label>

        <button
          type='submit'
          className='btn-primary px-4 py-2 rounded-full w-full text-base mx-auto mt-8 disabled:bg-zinc-500 disabled:text-zinc-400 disabled:cursor-not-allowed'
          onClick={handleCloseAccount}
          disabled={!isAcceptTerms}
        >
          Close My Account
        </button>


        <Transition appear show={isSuccessModalOpen} as={Fragment}>
          <Dialog
            as='div'
            className='relative z-50'
            onClose={() => setIsSuccessModalOpen(false)}
          >
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0'
              enterTo='opacity-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100'
              leaveTo='opacity-0'
            >
              <div className='fixed inset-0 bg-black/40 backdrop-blur-sm' />
            </Transition.Child>

            <div className='fixed inset-0 overflow-y-auto'>
              <div className='flex min-h-full items-center justify-center p-4 text-center'>
                <Transition.Child
                  as={Fragment}
                  enter='ease-out duration-300'
                  enterFrom='opacity-0 scale-95'
                  enterTo='opacity-100 scale-100'
                  leave='ease-in duration-200'
                  leaveFrom='opacity-100 scale-100'
                  leaveTo='opacity-0 scale-95'
                >
                  <Dialog.Panel className='relative font-dashboard w-full max-w-3xl min-h-[500px] transform overflow-hidden rounded-2xl bg-[#161819] px-4 pt-4 pb-10 text-left align-middle shadow-xl transition-all'>
                    <div className='relative py-24 flex flex-col items-center'>
                      <div className='flex flex-col items-center gap-4'>
                        <SuccessIcon />
                        <p className='text-xl font-light text-white/40'>
                          Account closed
                        </p>
                      </div>

                      <button
                        className='btn-primary py-2 rounded-lg w-full max-w-md mt-12'
                        onClick={() => {
                          setIsSuccessModalOpen(false)
                        }}
                      >
                        Done
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>

        </Transition>

      </div>
    </div>
  )
}
